export default __webpack_public_path__ + "static/media/osmosis-scientist-front.e2770a78.png";